// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608080057/js/" + chunkId + "." + {"44":"ba924007","225":"14f64616","481":"a48aaece","486":"abd58d19","770":"a73fcb66"}[chunkId] + ".0.4197852268348059.chunk.js";
};